import React, { Component } from "react";
import PropTypes from "prop-types";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { livemonitorSelector } from "store/selector";
import { messageAction } from "store/action";
import { connect } from "react-redux";
import ActionButtons from "./ActionButtons";
import Tip from "./Tip";
import { Button } from "modules/theme";
import { localStore } from "../../../../../helpers";
import { confirm } from "modules/theme";
import DynamicAgTableCustomFilterChatState from "./DynamicAgTableCustomFilterChatState";

export class DynamicCustomerChatTable extends Component {
    constructor(props) {
        super(props);
        this.renderList = this.renderList.bind(this);
        this.renderActions = this.renderActions.bind(this);
        this.handleModalOpen = this.handleModalOpen.bind(this);
        this.handleModalClose = this.handleModalClose.bind(this);
        this.columnList = [
            // { field: "sessionId", headerName: "SessionId", minWidth: 50, maxWidth: 100 },
            { field: "medium", headerName: "Medium", minWidth: 50, maxWidth: 100 },
            { field: "customer", headerName: "Customer" },
            {
                field: "status",
                headerName: "Status",
                filter: DynamicAgTableCustomFilterChatState,
                cellRenderer: this.renderStatus,
            },
            { field: "team", headerName: "Team" },
            { field: "campaign", headerName: "Campaign" },
            { field: "agent", headerName: "Agent" },
            {
                field: "humanTime",
                headerName: "Time Spent",
                // cellClass: this.cellClass,
                cellRenderer: this.cellClass,
                sort: "asc",
            },
            {
                field: "action",
                headerName: "Actions",
                cellRenderer: this.renderActions,
                minWidth: 50,
                maxWidth: 100,
            },
        ];
        this.oldList = {};
        this.state = {
            fullScreen: this.props.fullScreen,
            showChatModal: this.props.showChatModal,
            sChatData: this.props.sChatData,
        };
        console.log("statessadssas", this.props.list);
    }
    handleChatBargingClick = (params) => {
        console.log('paramsData', params.data)
        const isSessionIdMatched = this.props.list.some(
            (item) => item.id === params.data.id
            // (item) => item.callInfo.sessionId === params.data.callInfo.sessionId
        );

        if (isSessionIdMatched) {
            let dataBargeStartStop = {
                agent:
                    { userId: params.data.id, },
                userId: params.data.id,
                tenantId: localStore.getItem('selected-tenant'),
                eventMessage:
                {
                    type: "bargeIn",
                    from: "agent",
                    status: true,
                },
                sessionId: params.data.id,
                plateform: params.data.medium,
                payloadType: "event"
            }
            this.props.configProcessor("sendPayload", {
                ...dataBargeStartStop,
                "rmq:pattern": "global:event",
            });

            // this.handleModalOpen(params.data); // Directly open modal with data
            this.props.showChatModalTable(true);
            this.props.showChatModalData(params.data);
            this.props.monitorChat(params.data);
        } else {
            console.log("No matching sessionId found in the list");
        }
    };

    handleChatInboundBlockClick = (params) => {
        console.log('paramsData', params)
        const isSessionIdMatched = this.props.list.some(
            (item) => item.id === params.data.id
            // (item) => item.callInfo.sessionId === params.data.callInfo.sessionId
        );

        this.props.showChatInboundBlockModalTable(true);
        this.props.monitorChatInboundBlock(params.data);

        // if (isSessionIdMatched) {
        //     let dataBargeStartStop = {
        //         // agent:
        //         //     { userId: params.data.id, },
        //         userId: params.data.id,
        //         tenantId: localStore.getItem('selected-tenant'),
        //         // eventMessage:
        //         // {
        //         //     type: "inboundBlock",
        //         //     from: "admin",
        //         //     status: true,
        //         // },
        //         sessionId: params.data.id,
        //         plateform: params.data.medium,
        //         // platform: params.data.medium,
        //         // payloadType: "event",
        //         // identifier: params.data.identifier,
        //         chatInboundBlockType: "platform"
        //     }
        //     confirm("Do you want to block inbound Chat ?", {
        //         icon: "info",
        //         showConfirmation2: false,
        //     }).then((e) => {
        //         this.props.configProcessor("chatInboundBlock", {
        //             ...dataBargeStartStop,
        //             "rmq:pattern": "global:event",
        //         });
        //     });

        //     // this.handleModalOpen(params.data); // Directly open modal with data
        //     // this.props.showChatModalTable(true);
        //     // this.props.showChatModalData(params.data);
        //     // this.props.monitorChatInboundBlock(params.data);
        // } else {
        //     console.log("No matching sessionId found in the list");
        // }
    };

    handleChatHangupClick = (params) => {
        console.log('paramsData', params)
        const isSessionIdMatched = this.props.list.some(
            (item) => item.id === params.data.id
            // (item) => item.callInfo.sessionId === params.data.callInfo.sessionId
        );

        if (isSessionIdMatched) {
            let dataBargeStartStop = {
                // agent:
                //     { userId: params.data.id, },
                userId: params.data.id,
                tenantId: localStore.getItem('selected-tenant'),
                // eventMessage:
                // {
                //     type: "close",
                //     from: "admin",
                //     status: true,
                // },
                sessionId: params.data.id,
                plateform: params.data.medium,
                // payloadType: "event"
            }
            confirm("Do you want to hangup Chat ?", {
                icon: "info",
                showConfirmation2: false,
            }).then((e) => {
                this.props.configProcessor("chatHangup", {
                    ...dataBargeStartStop,
                    "rmq:pattern": "global:event",
                });
            });

            // this.handleModalOpen(params.data); // Directly open modal with data
            // this.props.showChatModalTable(true);
            // this.props.showChatModalData(params.data);
            // this.props.monitorChatInboundBlock(params.data);
        } else {
            console.log("No matching sessionId found in the list");
        }
    };

    handleModalOpen = (data) => {
        console.log("Data passed to modal:", data);

        const { showModalTable, showModalData } = this.props;

        // Set state and open modal without delay
        this.setState({ scData: data });
        showModalTable(true);
        showModalData(data);
    };

    handleModalClose = () => {
        // this.setState({ showModal: false });
        const { showModalTable } = this.props;
        // this.setState({ showModal: showModal });
        showModalTable(false);
        // this.props.setSummaryLoading(false);
        // this.props.clearSummary();
    };

    renderStatus(params) {
        if (params.value === "flow") {
            return <span className="ACW-box chips-common-style">{params.value}</span>;
        } else if (params.value === "queue") {
            return (
                <span className="Ringing-box chips-common-style">{params.value}</span>
            );
        } else if (params.value === "assigned") {
            return (
                <span className="Connected-box chips-common-style">{params.value}</span>
            );
        } else if (params.value === "closed") {
            return (
                <span className="Failed-box chips-common-style">{params.value}</span>
            );
        }
        return (
            <span className="yellow-box chips-common-style">{params.value}</span>
        );
    }

    shouldComponentUpdate(nextProps, nextState) {
        // console.log('Greeting - shouldComponentUpdate lifecycle');
        if (this.api && nextProps.list) {
            let result = this.getData(nextProps.list);
            this.api.applyTransactionAsync(result, (result) => {
                // console.log("result applyTransactionAsync ", result);
            });
        }
        return false;
    }
    getData(list) {
        let result = {
            update: [],
            add: [],
            remove: [],
        };
        let currentId = this.shortUuid();
        for (const data of list) {
            if (data.id && this.oldList && this.oldList[data.id]) {
                result.update.push(data);
            } else {
                result.add.push(data);
            }
            this.oldList[data.id] = currentId;
        }
        for (const key in this.oldList) {
            if (Object.hasOwnProperty.call(this.oldList, key)) {
                if (this.oldList[key] != currentId) {
                    result.remove.push({ id: key });
                    delete this.oldList[key];
                }
            }
        }
        return result;
    }
    shortUuid() {
        return (
            "0000" + ((Math.random() * Math.pow(36, 4)) | 0).toString(36)
        ).slice(-4);
    }
    componentWillReceiveProps(nextProps, prevState) {
        console.log("nextProps", nextProps);
        console.log({ checklist: this.props.list || {} });
        // console.log("nextProps", nextProps);
        // if (nextProps.agentList) {
        //   let current = JSON.stringify(nextProps.agentList);
        //   let previous = JSON.stringify(prevState.agentList);
        //   if (current !== previous) {
        //     let agentList = nextProps.agentList;
        //     let rowData = this.processAgent(agentList);
        //     let _this = this;
        //     this.setState({ agentList: agentList, rowData : rowData},()=>{
        //       _this.dataUpdate()
        //     })
        //   }
        // }
        // if ( nextProps.timeDiff != prevState.timeDiff ) {
        //   this.setState({ timeDiff: nextProps.timeDiff})
        // }
        this.setState({
            fullScreen: nextProps.fullScreen,
            showModal: nextProps.showModal,
        });
    }
    getColumnConf(columnsConf) {
        return (
            columnsConf || {
                resizable: true,
                floatingFilter: true,
                sortable: true,
            }
        );
    }
    getColumn(columns) {
        let columnDefs = [];
        if (columns && columns.length) {
            columns.map((column) => {
                column.minWidth = column.minWidth || 100;
                column.flex = column.flex || 1;
                column.filter = column.filter || true;
                column.maxWidth = column.maxWidth || 300;
                columnDefs.push(column);
            });
        }
        return columnDefs;
    }
    cellClass(params) {
        // if (params.data && params.data.diff) {
        //   if (params.data.diff > 1200) {
        //     return "bg-danger text-dark";
        //   } else if (params.data.diff > 900) {
        //     return "bg-warning text-dark";
        //   } else if (params.data.diff > 600) {
        //     return "bg-primary text-white";
        //   } else if (params.data.diff > 300) {
        //     return "bg-success text-dark";
        //   } else if (params.data.diff > 120) {
        //     return "bg-info text-dark";
        //   } else if (params.data.diff > 60) {
        //     return "bg-light text-dark";
        //   } else if (params.data.diff > 30) {
        //     return "bg-white text-dark";
        //   }
        // }
        // return "bg-white text-dark";
        if (params.data && params.data.diff) {
            if (params.data.diff > 1200) {
                return (
                    <Tip text={params.value}>
                        <span className="red-box chips-common-style">{params.value}</span>
                    </Tip>
                );
            } else if (params.data.diff > 900) {
                return (
                    <Tip text={params.value}>
                        <span className="yellow-box chips-common-style">
                            {params.value}
                        </span>
                    </Tip>
                );
            } else if (params.data.diff > 600) {
                return (
                    <Tip text={params.value}>
                        <span className="blue-box chips-common-style">{params.value}</span>
                    </Tip>
                );
            } else if (params.data.diff > 300) {
                return (
                    <Tip text={params.value}>
                        <span className="green-box chips-common-style">{params.value}</span>
                    </Tip>
                );
            } else if (params.data.diff > 120) {
                return (
                    <Tip text={params.value}>
                        <span className="info-box chips-common-style">{params.value}</span>
                    </Tip>
                );
            } else if (params.data.diff > 60) {
                return (
                    <Tip text={params.value}>
                        <span className="transparent-box chips-common-style">
                            {params.value}
                        </span>
                    </Tip>
                );
            } else if (params.data.diff > 30) {
                return (
                    <Tip text={params.value}>
                        <span className="white-box chips-common-style">{params.value}</span>
                    </Tip>
                );
            }
        }
        return <span className="white-box chips-common-style">{params.value}</span>;
    }
    getRowId(params) {
        return params.data.id;
    }
    renderActions(params) {
        const { monitorChat, configProcessor } = this.props;
        let _this = this;

        return (
            <ActionButtons>
                <span className="d-inline-block mr-3">
                    <Tip text={`${"Chat Barging"}`} key={this.shortUuid()}>
                        <Button
                            btnStyle="link"
                            style={{
                                verticalAlign: "middle",
                                color: "#28A6DE",
                                fontSize: "18px",
                                fontWeight: 600,
                            }}
                            onClick={() => this.handleChatBargingClick(params)}
                            className="material-symbols-outlined"
                        >
                            chat
                        </Button>
                    </Tip>
                </span>
                <span className="d-inline-block mr-3">
                    <Tip text={`${"Chat Inbound Block"}`} key={this.shortUuid()}>
                        <Button
                            btnStyle="link"
                            style={{
                                verticalAlign: "middle",
                                color: "#28A6DE",
                                fontSize: "18px",
                                fontWeight: 600,
                            }}
                            onClick={() => this.handleChatInboundBlockClick(params)}
                            className="material-symbols-outlined"
                        >
                            comments_disabled
                        </Button>
                    </Tip>
                </span>
                <span className="d-inline-block mr-3">
                    <Tip text={`${"Chat Hangup"}`} key={this.shortUuid()}>
                        <Button
                            btnStyle="link"
                            style={{
                                verticalAlign: "middle",
                                color: "#28A6DE",
                                fontSize: "18px",
                                fontWeight: 600,
                            }}
                            onClick={() => this.handleChatHangupClick(params)}
                            className="material-symbols-outlined"
                        >
                            chat_error
                        </Button>
                    </Tip>
                </span>
            </ActionButtons>
        )
        // if (
        //     params.data.state !== "IVR" &&
        //     params.data.state !== "Queue" &&
        //     params.data.state !== "Logout"
        // ) {
        //     return (
        //         <ActionButtons>
        //             <span className="d-inline-block mr-3">
        //                 {mainType == "call" && (
        //                     <Tip text={`${"Call Barging"}`} key={this.shortUuid()}>
        //                         <Button
        //                             btnStyle="link"
        //                             style={{
        //                                 verticalAlign: "middle",
        //                                 color: "#28A6DE",
        //                                 fontSize: "18px",
        //                                 fontWeight: 600,
        //                             }}
        //                             onClick={() => {
        //                                 console.log("here monitorcall running starting");
        //                                 monitorCall(params.data);
        //                             }}
        //                             className="material-symbols-outlined"
        //                         >
        //                             headset_mic
        //                         </Button>
        //                     </Tip>
        //                 )}
        //             </span>
        //             <span className="d-inline-block mr-3">
        //                 {mainType == "call" && (
        //                     <Tip text={`${"Message Barging"}`} key={this.shortUuid()}>
        //                         <Button
        //                             btnStyle="link"
        //                             style={{
        //                                 verticalAlign: "middle",
        //                                 color: "#28A6DE",
        //                                 fontSize: "18px",
        //                                 fontWeight: 600,
        //                             }}
        //                             onClick={() => this.handleBargingClick(params)}
        //                             // onClick={() => {
        //                             //   const isSessionIdMatched = this.props.list.some(
        //                             //     (item) =>
        //                             //       item.callInfo.sessionId ===
        //                             //       params.data.callInfo.sessionId
        //                             //   );
        //                             //   if (isSessionIdMatched) {
        //                             //     params.data.callInfo.status = "start";
        //                             //     this.handleModalOpen(params.data);
        //                             //     monitorTranscript(params.data);
        //                             //   } else {
        //                             //     console.log("No matching sessionId found in the list");
        //                             //   }
        //                             // }}
        //                             className="material-symbols-outlined"
        //                         >
        //                             record_voice_over
        //                         </Button>
        //                     </Tip>
        //                 )}
        //             </span>
        //             <span className="d-inline-block" style={{ width: 20 }}>
        //                 <Tip text={`${"Logout"}`} key={`${""}`}>
        //                     <Button
        //                         btnStyle="link"
        //                         style={{
        //                             verticalAlign: "middle",
        //                             color: "#E34242",
        //                             fontSize: "18px",
        //                             fontWeight: 600,
        //                         }}
        //                         disabled={this.state.fullScreen}
        //                         onClick={() => {
        //                             console.log("params force logout ", params.data);
        //                             confirm("Do you want to logout user?", {
        //                                 icon: "logout",
        //                                 showConfirmation2: false,
        //                             }).then((e) => {
        //                                 configProcessor("forcelogout", params.data);
        //                             });
        //                         }}
        //                         className="material-symbols-outlined"
        //                     >
        //                         power_rounded
        //                     </Button>
        //                 </Tip>
        //             </span>
        //         </ActionButtons>
        //     );
        // } else if (params.data.state === "IVR") {
        //     return (
        //         <ActionButtons>
        //             <span className="d-inline-block mr-3">
        //                 {/* {mainType == "call" && ( */}
        //                 <Tip text={`${"Call Barging"}`} key={this.shortUuid()}>
        //                     <Button
        //                         btnStyle="link"
        //                         style={{
        //                             verticalAlign: "middle",
        //                             color: "#28A6DE",
        //                             fontSize: "18px",
        //                             fontWeight: 600,
        //                         }}
        //                         onClick={() => {
        //                             console.log("here monitorcall running starting");
        //                             monitorCall(params.data);
        //                         }}
        //                         className="material-symbols-outlined"
        //                     >
        //                         headset_mic
        //                     </Button>
        //                 </Tip>
        //                 {/* )} */}
        //             </span>
        //             <span className="d-inline-block mr-3">
        //                 {/* {mainType == "call" && ( */}
        //                 <Tip text={`${"Message Barging"}`} key={this.shortUuid()}>
        //                     <Button
        //                         btnStyle="link"
        //                         style={{
        //                             verticalAlign: "middle",
        //                             color: "#28A6DE",
        //                             fontSize: "18px",
        //                             fontWeight: 600,
        //                         }}
        //                         onClick={() => this.handleBargingClick(params)}
        //                         // onClick={() => {
        //                         //   const isSessionIdMatched = this.props.list.some(
        //                         //     (item) =>
        //                         //       item.callInfo.sessionId === params.data.callInfo.sessionId
        //                         //   );
        //                         //   console.log(
        //                         //     "isSessionIdMatched",
        //                         //     this.props.list.some((item) => item.callInfo.sessionId),
        //                         //     params.data.callInfo.sessionId
        //                         //   );
        //                         //   if (isSessionIdMatched) {
        //                         //     params.data.callInfo.status = "start";
        //                         //     this.handleModalOpen(params.data);
        //                         //     monitorTranscript(params.data);
        //                         //   } else {
        //                         //     console.log("No matching sessionId found in the list");
        //                         //   }
        //                         //   // this.handleModalOpen();
        //                         //   // // console.log("here monitorTranscript running starting");
        //                         //   // monitorTranscript(params.data);
        //                         // }}
        //                         className="material-symbols-outlined"
        //                     >
        //                         record_voice_over
        //                     </Button>
        //                 </Tip>
        //                 {/* )} */}
        //             </span>
        //         </ActionButtons>
        //     );
        // } else return null;
    }
    renderList() {
        const { list } = this.props;
        let _this = this;
        console.log("renderList updated", list);
        if (list) {
            list.map((info) => {
                if (info.id) {
                    _this.oldList[info.id] = "INIT";
                }
            });
        }
    }

    render() {
        console.log("this.props.list", this.props.list);
        const {
            columns,
            columnsConf = "",
            agStyle = { width: "100%", height: "100%;" },
            divStyle = { height: 400, margin: "0px 0px 10px 0px" },
            agClassName = "ag-theme-alpine",
            boxClassName = "ag-theme-alpine",
            list = [],
            callTranscript,
        } = this.props;
        let _this = this;


        let columnDefs = this.getColumn(this.columnList);
        let defaultColDef = this.getColumnConf(columnsConf);
        console.log("Rerenceder---------------------");
        this.renderList();
        return (
            <div style={{ width: "100%", height: "100%" }}>
                <div
                    style={{ width: "100%", height: "100%" }}
                    className="ag-theme-quartz"
                >
                    <AgGridReact
                        style={agStyle}
                        className={agClassName}
                        onGridReady={(params) => {
                            _this.api = params.api;
                        }}
                        animateRows={true}
                        defaultColDef={defaultColDef}
                        enableRangeSelection="true"
                        rowData={list}
                        getRowId={this.getRowId}
                        rowSelection="multiple"
                        suppressRowClickSelection="true"
                        columnDefs={columnDefs}
                    />
                </div>
            </div>
        );
    }
}
DynamicCustomerChatTable.contextTypes = {
    __: PropTypes.func,
};

const stateToProps = (state) => ({
    list: livemonitorSelector.getLiveDynamic(state, { key: "liveChatList" }),
});

const dispatchToProps = (dispatch) => ({
    emitSocketMessage: (type, messageData) => {
        dispatch(messageAction.emitSocketMessage(type, messageData));
    },
    configProcessor: (type, messageData) => {
        dispatch(messageAction.configProcessor(type, messageData));
    },
});
export default connect(stateToProps, dispatchToProps)(DynamicCustomerChatTable);



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/DynamicCustomerChatTable.js.jsx